import { Injectable } from '@angular/core';
import {L10n, setCulture} from '@syncfusion/ej2-base';
import {FrenchLocale} from './locales';
import {SyncfusionTranslationType} from './syncfusion-translation-type';
import {SyncfusionComponentTranslation} from './syncfusion-component-types';
import {registerLocaleData} from '@angular/common';
import localeFr from '@angular/common/locales/fr';



@Injectable({
  providedIn: 'root'
})
export class SyncfusionLocalizationService {

  private translation: SyncfusionTranslationType;
  private currentLocale: string = FrenchLocale;

  constructor() {
    registerLocaleData(localeFr, FrenchLocale);
  }

  private initTranslation(locale: string) {
    if (this.translation == null || this.currentLocale != locale) {
      setCulture(locale);
      this.translation = {
      }
    }
  }

  loadTranslation(translation: SyncfusionComponentTranslation, locale: string = FrenchLocale) {
    this.initTranslation(locale);
    this.translation[locale] = translation;
    L10n.load(this.translation);
  }
}
